import { setValidationErrors } from '@sezenta/antd-schema-form';
import DayJs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { isDate } from 'radash';
import weekday from 'dayjs/plugin/weekday';

DayJs.extend(dayOfYear);
DayJs.extend(customParseFormat);
DayJs.extend(relativeTime);
DayJs.extend(updateLocale);
DayJs.extend(timezone);
DayJs.extend(utc);
DayJs.extend(weekday);
export const DefaultTimeZone = 'Australia/Melbourne';
DayJs.tz.setDefault(DefaultTimeZone);

DayJs.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years',
  },
});

export const dayjs = DayJs.tz;
export { DayJs };
export const setFormValidationErrors = (form: any, error: any) => {
  return setValidationErrors(form, { body: error.response.data });
};

export class Utils {
  static DEFAULT_TIME_FORMAT = 'HH:mm';
  static toDayJs(time: string | Date, timezone?: string) {
    if (isDate(time)) {
      return DayJs.utc(time.toISOString()).tz(timezone ?? DefaultTimeZone);
    }
    return DayJs.utc(time).tz(timezone ?? DefaultTimeZone);
  }

  static getLuminance = (r: number, g: number, b: number) => {
    const a = [r, g, b].map((v) => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  };

  // Function to convert hex to RGB
  static hexToRgb = (hex: string) => {
    let r = 0,
      g = 0,
      b = 0;
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    }
    return [r, g, b];
  };

  // Function to determine if color is light or dark
  static getTextColor = (hexColor?: string) => {
    const [r, g, b] = Utils.hexToRgb(hexColor ?? '#FFFFFF');
    const luminance = Utils.getLuminance(r, g, b);
    return luminance > 0.5 ? 'black' : 'white';
  };

  static formatPrice(val: number | string, autoDecimal?: boolean) {
    if (val === undefined) {
      val = 0;
    }
    const v = (typeof val === 'string' ? parseFloat(val) : val) / 100;
    const decimals = autoDecimal && v >= 1000 ? 0 : 2;

    return Number(v.toFixed(decimals)).toLocaleString('en', {
      minimumFractionDigits: decimals,
    });
  }

  static formatPriceNew(val: number | string, autoDecimal?: boolean) {
    if (val === undefined) {
      val = 0;
    }
    const v = typeof val === 'string' ? parseFloat(val) : val;
    const decimals = autoDecimal && v >= 1000 ? 0 : 2;

    return Number(v.toFixed(decimals)).toLocaleString('en', {
      minimumFractionDigits: decimals,
    });
  }
}
